import type {
  AddCommandOptions,
  BetterstartCommandRuntime
} from '@cli-types/core-engine/commands.js'
import { renderCommandHelpText } from '@core-engine/templates/renderers/commands/command-help.js'
import { Command } from 'commander'

export function createAddCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('add')
    .description('Install BetterStart presets or integrations into an existing Admin')
    .argument('<items...>', 'Preset or integration IDs to install (e.g. blog, r2)')
    .option('-y, --yes', 'Skip interactive configuration prompts', false)
    .option('--integration', 'Install integration IDs instead of content preset IDs', false)
    .option(
      '--skip-migration',
      'Skip running db:push after installing schema-backed presets',
      false
    )
    .option('--cwd <path>', 'Project root path')
    .addHelpText('after', renderCommandHelpText('add'))
    .action((items: string[], options: AddCommandOptions) => runtime.runAdd(items, options))
}
